<template>
  <v-toolbar flat color="transparent">
    <v-spacer></v-spacer>
    <custom-button
      v-if="mixValidaScopesActions(1)"
      label="Nuevo"
      iconText="mdi-plus"
      tipo="agregar"
      @click="registrarSuperintendente">
    </custom-button>
  </v-toolbar>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'SuperintendenteToolBar',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    registrarSuperintendente() {
      this.$emit('registrarSuperintendente');
    },
  },
};
</script>

<style lang="scss">

</style>
